export enum XenditCreditCardStatusEnum {
  verified = 'VERIFIED',
  in_review = 'IN_REVIEW',
  failed = 'FAILED',
  approved = 'APPROVED',
  card_enrolled = 'CARD_ENROLLED',
  fraud = 'FRAUD',
}
